export default class subscriberFormTagSelect {
    constructor() {
        var tagSelect = null;
        
        return {
            restrict: 'A',
            scope: {
                loadedTags: '='
            },
            controller: ['$scope', '$element', '$timeout', '$filter', 'SweetAlert', 'Tag',
                ($scope, $element, $timeout, $filter, SweetAlert, Tag) => {
                $timeout(() => {
                    tagSelect = $($element).selectize({
                        valueField: 'id',
                        labelField: 'name',
                        searchField: 'name',
                        plugins: ['remove_button'],
                        preload: true,

                        render: {
                            item: function(item, escape) {
                                return'<div class="tag-label"><a style="color:inherit;" href="#/tag/' + item.id + '">' +
                                    escape(item.name) +
                                    '</a></div>';
                            }
                        },

                        load: (query, callback) => {
                            if (! query.length) {
                                return Tag.all().then((tags) => {
                                    callback(tags.data);
                                });
                            }

                            Tag.findByName(query).then((tags) => {
                                callback(tags);
                            });
                        },

                        create: (input, callback) => {
                            SweetAlert.swal({
                                title: $filter('translate')('TAG:CREATE:NEW_TAG'),
                                text: $filter('translate')('TAG_MODAL:CREATE:CREATE'),
                                type: "info",
                                showCancelButton: true,
                                confirmButtonText: $filter('translate')('GLOBAL:YES'),
                                cancelButtonText: $filter('translate')('GLOBAL:NO')
                            }, (isConfirm) => {
                                if (isConfirm) {
                                    return Tag.store(input).then((tag) => {
                                        $timeout(() => {
                                            tagSelect[0].selectize.addOption({id: tag.data.id, name: tag.data.name});
                                            tagSelect[0].selectize.addItem(tag.data.id);
                                            tagSelect[0].selectize.unlock();
                                            callback();
                                        });
                                    }, () => {
                                        SweetAlert.swal({
                                            title: $filter('translate')('TAG:FLASH:CREATE_ERROR'),
                                            text: $filter('translate')('TAG:FLASH:DUPLICATE'),
                                            type: 'error'
                                        });

                                        tagSelect[0].selectize.unlock();
                                        callback();
                                    });
                                } else {
                                    tagSelect[0].selectize.unlock();
                                    callback();
                                }
                            });
                        }
                    });

                    $scope.$watch('loadedTags', (newVal) => {
                        $timeout(() => {
                            tagSelect[0].selectize.clear();
                            tagSelect[0].selectize.clearOptions();
                        });

                        if (newVal !== false) {
                            _.map(newVal, (tag) => {
                                $timeout(() => {
                                    tagSelect[0].selectize.addOption({id: tag.id, name: tag.name});
                                    tagSelect[0].selectize.addItem(tag.id);
                                });
                            });
                        }
                    })
                })
            }]
        }
    }
};
